import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { Toast } from 'vant';

import api from '@/api/axios'
// vant组件
import components from './plugins/components';
import antdVue from './plugins/antdVue';
import routePushShare from './plugins/getShareCode';
// 埋点
// css
import './static/style/index.less';
import './static/style/carrier-list.less';

router.beforeEach((to, from, next) => {
  store.dispatch('getUserInfo').
  then(res => {
    this.userInfo = res;
    store.commit('WRITEUSERLEVEL', res.userLevel || null);
  }).
  catch(() => {}).
  finally(() => {
    store.commit('WRITENEXTPAGE', to);
    if (to.meta.shareTitle) routePushShare();
    document.title = to?.meta?.title || '壁虎看看'
    Toast.clear();
    next();
  })
});
Vue.config.productionTip = false;
Vue.use(components);
Vue.use(antdVue);
Vue.use(api)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
